import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import selectTheme from '../../../../../helpers/selectTheme';
import Select from 'react-select';

class CampaignsStatusFilter extends Component {
  static propTypes = {
    label: PropTypes.string,
    labelSize: PropTypes.number,
    infoButton: PropTypes.element,
  };

  render() {
    const { statusFilter, typeFilter } = this.props;
    const options = statusFilter ? statusOptions : typeFilter ? typeOptions : '';

    return (
      <Select
        theme={(theme) => selectTheme(theme)}
        options={options}
        isClearable
        {...this.props}
      />
    );
  }
}

const typeOptions = [
  { value: 'Campaign', label: 'Campaign' },
  { value: 'Commission Adjustment', label: 'Commission Adjustment' },
];
const statusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'pending', label: 'Pending' },
  { value: 'ended', label: 'Ended' },
  { value: '', label: 'All' },
];

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(CampaignsStatusFilter);
